import React, { Component } from "react";
import { Line } from "react-chartjs-2";

class SocialStatsChart extends Component {
  render() {
    const kFormatter = num => {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    };

    Chart.defaults.global.defaultFontColor = "#fff";

    // let tcolor = "var(--h1Color)";

    const data = {
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
      datasets: [
        {
          label: "Reddit",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#68edff",
          borderColor: "#68edff",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#68edff",
          pointBackgroundColor: "#68edff",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgba(75,192,192,1)",
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [0, 3000, 3500, 4100, 4500, 5800, 6000]
        },

        {
          label: "Telegram",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#fff",
          borderColor: "#cc7164",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#cc7164",
          pointBackgroundColor: "#cc7164",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#cc7164",
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [0, 2000, 2500, 3100, 4500, 6500, 7800]
        },

        {
          label: "Twitter",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#fff",
          borderColor: "#049bf0",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#049bf0",
          pointBackgroundColor: "#049bf0",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#049bf0",
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [0, 3500, 4000, 5100, 6500, 7800, 8000]
        }
      ]
    };

    const lineOptions = {
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: true
            },
            ticks: {
              maxLines: 3,
              beginAtZero: true,
              userCallback(value) {
                value = kFormatter(value);
                return value;
              }
            }
          }
        ]
      },
      legend: {
        display: false
      },
      tooltips: {
        enabled: true
      }
    };

    return <Line data={data} options={lineOptions} />;
  }
}

export default SocialStatsChart;
